export default {
  name: "pro-enc-input-show",
  props: {
    decodeValue: {
      type: String,
      default() {
        return "";
      }
    },
    encodeValue: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      eyeShow: false
    };
  }
};